/* istanbul ignore file */
import Bowser from "bowser";

export const BROWSER = Bowser.getParser(window.navigator.userAgent);
export function isMobilePlateform() {
  return BROWSER.getPlatformType() === 'mobile' || BROWSER.getPlatformType() === 'tablet';
}